import { render, staticRenderFns } from "./SithMesPrdRoutingSummaryDetailList.vue?vue&type=template&id=ded21c82&"
import script from "./SithMesPrdRoutingSummaryDetailList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdRoutingSummaryDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports